import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:ANALYTICS";

export const getMappingMetricsGroups = () => {
    LogService.trace(LOG_TAG, "getMappingMetricsGroups", "enter");

    return RainbowServerFetch.get("/api/rainbow/metrics/v1.0/cpaasmetrics/apigroupsmapping")
        .then(response => {
            LogService.trace(LOG_TAG, "getMappingMetricsGroups", "successfully received the application metrics");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getMappingMetricsGroups", "error when retrieving the application metrics");
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        })
};

export const getApplicationMetrics = (appId, fromDay, toDay, period, dcZones) => {
    LogService.trace(LOG_TAG, "getApplicationMetrics", "enter");

    let param = "?fromDate=" + fromDay;

    //let timeZone = moment.tz.guess(); //example: "Europe/Paris";
    //param += "&timezone=" + encodeURIComponent(timeZone);

    param += "&toDate=" + toDay;
    param += "&period=" + period;
    if (dcZones && typeof dcZones === "object" && dcZones.length) {
        param += "&dcZones=" + dcZones.join(",");
    }

    return RainbowServerFetch.get(`/api/rainbow/metrics/v1.0/cpaasmetrics/${appId}${param}`)
        .then(response => {
            LogService.info(LOG_TAG, "getApplicationMetrics", "successfully received the application metrics");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getapplicationMetrics", "error when retrieving the application metrics", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
};

export const updateApplicationThreshold = (appID, groupName, thresholdType, notification, value) => {
    LogService.trace(LOG_TAG, "updateApplicationThreshold", "enter");
    const data = {
        notification: notification,
        threshold: value
    };
    const body = JSON.stringify(data);

    return RainbowServerFetch.put(`/api/rainbow/applications/v1.0/applications/${appID}/thresholds/${groupName}/${thresholdType}`, body)
        .then(response => {
            LogService.info(LOG_TAG, "updateApplicationThreshold", "successfully updated the application threshold");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "updateApplicationThreshold", "error when updating the application threshold", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
};

export const deleteApplicationThreshold = (appID, groupName, thresholdType) => {
    LogService.trace(LOG_TAG, "deleteApplicationThreshold", "enter");

    return RainbowServerFetch.delete(`/api/rainbow/applications/v1.0/applications/${appID}/thresholds/${groupName}/${thresholdType}`)
        .then(() => {
            LogService.info(LOG_TAG, "deleteApplicationThreshold", "successfully deleted the application threshold");
            return Promise.resolve();
        })
        .catch(error => {
            LogService.error(LOG_TAG, "deleteApplicationThreshold", "error when deleting the application threshold", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
};

export const createApplicationThreshold = (appID, groupName, notification, value) => {
    LogService.trace(LOG_TAG, "createApplicationThreshold", "enter");
    const data = {
        type: "custom",
        notification: notification,
        threshold: value
    };

    const body = JSON.stringify(data);

    return RainbowServerFetch.post(`/api/rainbow/applications/v1.0/applications/${appID}/thresholds/${groupName}`, body)
        .then((response) => {
            LogService.info(LOG_TAG, "createApplicationThreshold", "successfully received the application threshold");
            return Promise.resolve(response);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "createApplicationThreshold", "error when creating the application threshold", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
};

export const getApplicationThresholds = (appID) => {
    LogService.trace(LOG_TAG, "getApplicationThresholds", "enter");

    return RainbowServerFetch.get(`/api/rainbow/applications/v1.0/applications/${appID}/thresholds`)
        .then(response => {
            LogService.info(LOG_TAG, "getApplicationThresholds", "successfully received the application thresholds");
            return Promise.resolve(response.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getApplicationThresholds", "error when retrieving the application thresholds", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
};